const styles = {
  boxItem: {
      border:'1px solid #dcdcdc',height:'200px',padding:'10px',position:'relative'
  },  
  detailItem: {
      color:'#79a5b7',fontSize:'25px',marginTop:'5px',
      position:'absolute',top:'0px',right:'5px'
  },
  titleItem:{
      textAlign:'center',overflow:'hidden',height:'80px',
      "& h5": {
          marginBottom:'0px'
      },
      "& label":{
          color:'#79a5b7',fontSize:'11px',fontWeight:'500'
      }
  },
  valueItem:{
      textAlign:'center',marginBottom:'10px',marginTop:'10px'
  },
  titleModalAdd:{
      background:'#5c4477',position:'relative',
      "& h4": {
          color:'white'
      },
      "& button":{
          position:'absolute',right:'10px',top:'10px',color:'#d0d0d0'
      }
  },
  dialogbackgroundwhite:{
      background:'white'
  },
  sizeModalAdd:{
      width:'300px'
  },
  titleItemModalAdd:{
      width:'70%',float:'left'
  },
  valueItemModalAdd:{
      marginleft:'20px',marginTop:'10px',color:'#79a5b7',float:'right'
  },
  discountValueModalAdd:{
      textDecoration:'line-through',color:'gray'
  },
  totalValueModalAdd:{
      fontSize:'25px',fontWeight:'400',marginLeft:'10px'
  },
  titleModalDetail:{
      background:'#79a5b7',position:'relative',
      "& h4": {
          color:'white'
      },
      "& button":{
          position:'absolute',right:'10px',top:'10px',color:'#d0d0d0'
      }
  },
  sizeModalDetail:{
      width:'500px',padding:'10px'
  },
  textGray: {
    color: '#999',
  },
  btnSemEstoque: {
    background: '#eaeaeb',
    color: '#3d3d3e',
    padding: '0.40625rem 1.25rem',
    margin: '0.3125rem 2.188rem',
    fontSize: '0.6875rem',
    borderRadius: '0.2rem', 
    lineHeight: '1.5',
    minWidth: 'auto',
    minHeight: 'auto',
    textAlign: 'center',
  },
};
  
  export default styles;